export default __webpack_public_path__ + "static/1-5f9b2bb352ee0f406508ad51432bf12e.png";